import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './App.css';
import './styles/fonts.css';
import { Home } from './pages/Home/Home';

import { Price as PricePage } from 'pages/Charts/Price';
import { Bundle as BundlePage } from 'pages/Charts/Bundle';
import { AllCharts as AllChartsPage } from 'pages/Charts/AllCharts';
import { TradePage } from 'pages/Calculate/Trade'
import { VaultPage } from 'pages/Calculate/Vault'

import { Context } from 'data/context';
import { useCurrencies } from 'hooks/useCurrencies';
import { useProducts } from 'hooks/useProducts';
import { NotFound } from 'pages/NotFound';
import { Page } from 'components/Core';
import { useAppTheme } from 'hooks/useAppTheme';
import { AllCalculators } from 'pages/Calculate/AllCalculators';

function App() {
  const theme = useAppTheme();
  const currencies = useCurrencies();
  const products = useProducts({ showAll: true });

  return (
    <div className="App">
      <Context.Provider value={{ currencies, products, theme }}>
        <Router>
          <Routes>
            <Route path="/" element={
              <Page theme="blue" hasLogo>
                <Home />
              </Page>
            } />
            <Route path="/charts" element={
              <Page theme={theme}>
                <AllChartsPage />
              </Page>
            } />
            <Route path="/charts/price" element={
              <Page theme={theme}>
                <PricePage />
              </Page>
            } />
            <Route path="/charts/bundle" element={
              <Page theme={theme}>
                <BundlePage />
              </Page>
            } />
            <Route path="/calculate" element={
              <Page theme="blue" hasLogo>
                <AllCalculators />
              </Page>
            }/>

            <Route path="/calculate/trade" element={
              <Page theme={theme}>
                <TradePage />
              </Page>
            } />
            <Route path="/calculate/vault" element={
              <Page theme={theme}>
                <VaultPage />
              </Page>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </Context.Provider>
    </div>
  );
}

export default App;
